import type { TechnologyLockRow } from '../../codingconstitution/framework';

type Props = { items?: TechnologyLockRow[] };

export function TechnologyLockPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.category}-${item.technology}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs text-slate-400">{item.category}</p>
              <p className="text-sm font-medium">{item.technology}</p>
            </div>
            <div className="text-right">
              <p className="text-xs text-slate-500">{item.version}</p>
              <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">
                {item.status}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
